<template>
  <div class="no-recipe-list">
    <div class="no-recipe-list-container">
      <img src="@/assets/home/recipe-list.svg" alt="" />
      <p>学校暂未公示本周食谱</p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scope>
.no-recipe-list {
  margin: 0rem 0.2rem;
  padding-top: 0.5rem;
  height: calc(100vh - 2.6rem);
  box-sizing: border-box;
  .no-recipe-list-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    // margin-top: 1rem;
    width: 100%;
    height: 6rem;
    border-radius: 0.2rem;
    box-shadow: 0px 2px 40px 0px rgba(36, 42, 56, 0.12);
    background-color: #fff;
    img {
      width: 2rem;
      height: 2rem;
    }
    p {
      margin-top: 0.3rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: center;
      color: rgba(0, 0, 0, 0.6);
      font-size: 0.3rem;
    }
  }
}
</style>